import { Link } from "react-router-dom";
import Marquee from "react-fast-marquee";

const cities = ["salt-lake-city", "brigham-city", "draper", "ogden", "provo", "sandy", "west-valley-city"];
const cityNames = { "salt-lake-city": "Salt Lake City", "brigham-city": "Brigham City", draper: "Draper",
  ogden: "Ogden", provo: "Provo", sandy: "Sandy", "west-valley-city": "West Valley City" };

export const Footer = () => (
  <footer data-testid="site-footer" className="bg-ink2 border-t border-bone/10 pt-20">
    <Marquee speed={40} gradient={false} className="overflow-hidden py-6 border-y border-bone/10 mb-16">
      <span className="font-display font-extrabold uppercase text-5xl md:text-7xl text-bone/10 tracking-tighter mx-8">
        Locally Rooted · Pharmacist Led · Utah Grown · Beehive Pharmacy ·&nbsp;
      </span>
    </Marquee>

    <div className="max-w-[1600px] mx-auto px-6 lg:px-12 grid grid-cols-1 md:grid-cols-4 gap-12 pb-16">
      <div className="md:col-span-1">
        <div className="font-display font-extrabold text-3xl tracking-tighter uppercase mb-4">
          Bee<span className="text-honey">hive</span>
        </div>
        <p className="text-stone text-sm leading-relaxed">
          Utah&rsquo;s pharmacist-led medical cannabis pharmacy. Verified, lab-tested, and locally rooted.
        </p>
      </div>

      <div>
        <div className="text-xs tracking-[0.2em] uppercase font-bold text-honey mb-5">Shop</div>
        <ul className="space-y-3 text-sm text-stone">
          <li><Link to="/menu" className="hover:text-honey transition-colors">Full Menu</Link></li>
          <li><Link to="/menu?category=Flower" className="hover:text-honey transition-colors">Flower</Link></li>
          <li><Link to="/menu?category=Edibles" className="hover:text-honey transition-colors">Edibles</Link></li>
          <li><Link to="/menu?category=Vaporizers" className="hover:text-honey transition-colors">Vaporizers</Link></li>
        </ul>
      </div>

      <div>
        <div className="text-xs tracking-[0.2em] uppercase font-bold text-honey mb-5">Service Areas</div>
        <ul className="space-y-3 text-sm text-stone">
          {cities.map((c) => (
            <li key={c}><Link to={`/locations/${c}`} className="hover:text-honey transition-colors">{cityNames[c]}</Link></li>
          ))}
        </ul>
      </div>

      <div>
        <div className="text-xs tracking-[0.2em] uppercase font-bold text-honey mb-5">Get Started</div>
        <ul className="space-y-3 text-sm text-stone">
          <li><Link to="/medical-card" className="hover:text-honey transition-colors">Get Your Medical Card</Link></li>
          <li><a href="tel:+18018839099" className="hover:text-honey transition-colors">(801) 883-9099</a></li>
          <li className="pt-2 text-xs">Must be 21+ or a registered UT medical cannabis patient.</li>
        </ul>
      </div>
    </div>

    <div className="border-t border-bone/10 py-6">
      <div className="max-w-[1600px] mx-auto px-6 lg:px-12 flex flex-col md:flex-row justify-between gap-3 text-xs text-stone">
        <span>© {new Date().getFullYear()} BeeHive Pharmacy. All rights reserved.</span>
        <span>Utah Medical Cannabis · License #PH-XXXX</span>
      </div>
    </div>
  </footer>
);
